import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import cx from 'classnames';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import app from 'new-ui/app';
import { useTranslation } from 'utils/modifiedTranslation';
import { USER_TYPE_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { ReactComponent as SupportIcon } from 'assets/icons/support.svg';
import { ReactComponent as TreatmentIcon } from 'assets/icons/treatment_icon.svg';
import { preserveQueryParam } from 'functions/preserveQueryParam';
import { GA_HCP } from 'modules/ga/hcp';
import { TAB_IDS } from '../constants';
import { SUPPORTED_TAB_IDS } from './constants';
import styles from './menuItems.module.css';

export const MenuItems = ({
  tabIds, onMenuItemClick, activeItem,
}) => {
  const { t } = useTranslation();

  return (
    <ul className={styles.root}>
      {tabIds.includes(TAB_IDS.HCP_TREATMENT_OPTIONS) && (
        <li
          className={cx(styles.item, { [styles.activeItem]: TAB_IDS.HCP_TREATMENT_OPTIONS === activeItem })}
          onClick={() => onMenuItemClick((dispatch) => {
            dispatch(push(preserveQueryParam(ROUTE_PATH[ROUTE_NAME.SEARCH], {
              pick: [USER_TYPE_URL_SEARCH_PARAM],
            })));
          })}
        >
          <div className={styles.itemIcon}>
            <TreatmentIcon />
          </div>
          <div className={styles.itemTitle}>
            {t('general.treatment_options')}
          </div>
        </li>
      )}
      {tabIds.includes(TAB_IDS.HCP_SUPPORT_PROGRAMS) && (
        <li
          className={cx(styles.item, { [styles.activeItem]: TAB_IDS.HCP_SUPPORT_PROGRAMS === activeItem })}
          onClick={() => onMenuItemClick((dispatch) => {
            dispatch(push(preserveQueryParam(ROUTE_PATH[ROUTE_NAME.PUBLIC_FINANCE], {
              pick: [USER_TYPE_URL_SEARCH_PARAM],
            })));
            app.sendGoogleAnalyticsEvent(GA_HCP.category, GA_HCP.events.FINANCE_TAB_CLICKED);
          })}
        >
          <div className={styles.itemIcon}>
            <SupportIcon />
          </div>
          <div className={styles.itemTitle}>
            {t('general.support_programs')}
          </div>
        </li>
      )}
    </ul>
  );
};

MenuItems.propTypes = {
  tabIds: PropTypes.arrayOf(PropTypes.oneOf(Object.values(SUPPORTED_TAB_IDS))).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  activeItem: PropTypes.string,
};
